import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Magento\\GiftRegistry module that allows to create sets of gifts specified for specific holiday(Birthday, Wedding, etc).
It resembles wishlist, but there are differences. You can describe Gift Registry as a wishlist of products you would
like to share with other people so they could purchase anything from the list. Customer can even set some shipping
address to a gift registry, thus anyone who follows this list with a purchase would automatically have that shipping
address set by default during checkout. Customer can manage his gift registries in his profile. The gift registry can be
shared or stay private. Every gift registry has system attributes and can have custom attributes.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 101.2.8.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      